import ResponsiveStyleSheet from "react-native-media-query";
import { createResponsiveStyles, theme } from "@clearabee/ui-library-native";

export const { styles, ids } = ResponsiveStyleSheet.create({
  container: createResponsiveStyles({
    base: { marginTop: theme.spacing.xsmall },
    medium: { marginTop: theme.spacing.xlarge },
    xlarge: { flexDirection: "row" },
  }),
  accordionWrapper: createResponsiveStyles({
    base: {
      flex: 1,
    },
    xlarge: {
      marginRight: theme.spacing.xsmall,
    },
  }),
});
